import { Flex, Box, Image } from "@chakra-ui/react";
import React from "react";
import uploadIcon from "../assets/export.svg";

const ExportEmployeeBtn = () => {
  return (
    <Flex
      backgroundColor={"blue.600"}
      w={"fit-content"}
      gap={2}
      borderRadius={"15px"}
      p={["3px 10px", "5px 15px"]}
      justifyContent={"center"}
      alignItems={"center"}
      _hover={{ backgroundColor: "blue.700" }}
      transition="background-color 0.3s ease"
    >
      <Flex
        borderRadius={"50%"}
        backgroundColor={"white"}
        w={["20px", "35px"]}
        h={["20px", "35px"]}
        justifyContent={"center"}
        alignItems={"center"}
        p={2}
      >
        <Image src={uploadIcon} />
      </Flex>
      <Box w={["4rem", "10rem"]}>
        <Box color={"white"} fontSize={["small", ""]}>
          {"Export Employee"}
        </Box>
      </Box>
    </Flex>
  );
};

export default ExportEmployeeBtn;
